// categoryRouteMap.js
export const categoryRouteMap = {
  "1.1 Stationary Combustion": "cat1_1",
  "1.2 Mobile Combustion": "cat1_2",
  "1.3 Industrial Processes": "cat1_3",
  "1.4 Fugitive Emissions": "cat1_4",
  "1.5 Land Use, Land Use Change and Forestry (LULUCF)": "cat1_5",
  "2.1 Imported Electricity": "cat2_1",
  "2.2 Imported Energy": "cat2_2",
  "3.1 Upstream Transport and Distribution for Goods": "cat3_1",
  "3.2 Downstream Transport and Distribution for Goods": "cat3_2",
  "3.3 Employee Commuting": "cat3_3",
  "3.4 Client and Visitor Transport": "cat3_4",
  "3.5 Business Travel": "cat3_5",
  "4.1 Goods Purchased by an Organization": "cat4_1",
  "4.2 Capital Goods that are Purchased and Amortized by an Organization":
    "cat4_2",
  "4.3 Disposal Services (of solid or liquid waste) Used by an Organization":
    "cat4_3",
  "4.4 Use of Assets (through leased equipment) by an Organization": "cat4_4",
  "4.5 Use of Services not Described in the above sub-categories by an Organization":
    "cat4_5",
  "5.1 Use Stage of the Product": "cat5_1",
  "5.2 Downstream Leased Assets": "cat5_2",
  "5.3 End of Life Stage of the Product": "cat5_3",
  "5.4 Investments": "cat5_4",
  "6.1 Indirect GHG Emissions from other sources": "cat6_1",
  "1.1 Direct Emissions from Stationary Combustion": "cat1_1",
  "1.2 Direct Emissions from Mobile Combustion": "cat1_2",
  "1.3 Direct Emissions from Process Sources": "cat1_3",
  "1.4 Direct Emissions from Fugitive Sources": "cat1_4",
  "1.5 Direct Emissions from Agricultural Sources": "cat1_5",
  "2.1 Indirect Emissions from Purchased/Acquired Electricity": "cat2_1",
  "2.2 Indirect Emissions from Purchased/Acquired Steam": "cat2_2",
  "2.3 Indirect Emissions from Purchased/Acquired Heating": "cat2_2",
  "2.4 Indirect Emissions from Purchased/Acquired Cooling": "cat2_2",
  "3.4 Upstream Transportation and Distribution": "cat3_1",
  "3.6 Business Travel": "cat3_5",
  "3.7 Employee Commuting": "cat3_3",
  "3.9 Downstream Transportation and Distribution": "cat3_2",
  "3.1 Purchased Goods and Services": "cat4_1",
  "3.2 Capital Goods": "cat4_2",
  "3.3 Fuel and Energy-related Activities(not included in Scope 1 or Scope 2)":
    "cat4_1",
  "3.5 Waste Generated in Operations": "cat4_3",
  "3.8 Upstream Leased Assets": "cat4_4",
  "3.10 Processing of Solid Products": "cat5_1",
  "3.11 Use of Solid Products": "cat5_1",
  "3.12 End-of-Life Treatment of Solid Products": "cat5_3",
  "3.13 Downstream Leased Assets": "cat5_2",
  "3.14 Franchise (Scope 1 and Scope 2)": "cat6_1",
  "3.15 Investments": "cat5_4",
  "Emission Removal & Mitigation": "rm",
};
